export type ClientConfig = {
  cookiePolicyId: string;
  genericLoginFlow: boolean;
};

const empty = (): ClientConfig => ({
  cookiePolicyId: '',
  genericLoginFlow: false,
});

export const ClientConfig = {
  empty,
};
